import { useContext } from 'react';
import { SiteNotificationsContext, SiteNotificationsTools } from '@app/site/secured/rateshopper/rates/provider/SiteNotificationsProvider';

export const useSiteNotificationTools = (): SiteNotificationsTools => {
	return useContext(SiteNotificationsContext)!;
};